import { useEffect, useState } from 'react';
import { getMemberList } from '../services/manage/accounts';
import { ServiceRegionType } from '../type';

export const useMemberList = (authContext: any, region: ServiceRegionType) => {
    const [memberList, setMemberList] = useState<any>([]);

    useEffect(() => {
        const fetchMemberList = async () => {
            const response = await getMemberList({ token: authContext.token });
            if (response?.result?.code === '0000' && Array.isArray(response?.applicationTeamMemberList)) {
                setMemberList(response.applicationTeamMemberList);
            }
        };
        fetchMemberList();
    }, [authContext.token, region]);

    return { memberList };
};
